import React from 'react'
import JSONLDContainer from './Container'

export interface JSONLDProps {
  content: object | null
}

export default function JSONLD(props: JSONLDProps) {
  if (props.content === null) {
    return <></>
  } else {
    return <JSONLDContainer content={JSON.stringify(props.content)} />
  }
}
